import {TOGGLE_MENU} from './actionTypes';

export const toggleMenu = () => ({
  type: TOGGLE_MENU,
});
